let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/conseil/conseil'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click #btn-show-form-conseil': 'form',
      'click .show-conseil': 'select',
      'click .edit-conseil': 'update',
      'click .delete-conseil': 'delete'
    })
  },
  list () {
    let data = $('#form-pagination').serialize()

    $('#conseil-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

    app.ajax({
      url: '/conseil',
      data,
      success: (...args) => this.refreshList(...args)
    })
  },
  refreshList (conseils, status, xhr) {
    $('#conseil-list').html(require('views/templates/conseil/list')({
      conseils,
      searchTerms: xhr.getResponseHeader('ps-search-term'),
      total: xhr.getResponseHeader('ps-total-row')
    })).show()

    app.initList()
  },
  update (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    if (id) {
      app.ajax({
        url: '/conseil',
        data: { id },
        complete: app.onComplete({
          success: (res) => this.form(res)
        })
      })
    }
  },
  form (data) {
    let bb = bootbox.dialog({
      title: 'Ajouter un conseil',
      message: require('views/templates/conseil/form')(data),
      size: 'large',
      buttons: {
        save: {
          label: 'Enregistrer',
          className: 'btn-success',
          callback: (e) => {
            if (e) e.preventDefault()

            let type = 'POST'
            if ($('#id-conseil').val()) {
              type = 'PUT'
            }
            let data = $('#conseil-form').serialize()
            app.ajax({
              url: '/conseil',
              type,
              data,
              complete: app.onComplete({
                success: (id) => {
                  bb.modal('hide')
                  this.list()
                }
              })
            })
            return false
          }
        },
        cancel: {
          label: 'Annuler'
        }
      }
    })

    bb.init(() => {
      bb.removeAttr('tabindex') // SInon le select 2 n'est pas modifiable

      this.prepareFormEvent()
    })

    // $('#conseil-form-ctn').empty().html(require('views/templates/conseil/form')(data)).show()
    // $('#btn-show-form-conseil').attr('disabled', true)
    // this.prepareFormEvent()
  },
  prepareFormEvent (e) {
    app.select2('#id-evenement-ui', {
      ajax: {
        url: '/events',
        type: 'GET',
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return { q: params.term, 'filter-actif': 1, tri: 'date', trid: 'asc' }
        },
        processResults: function (data) {
          return {
            results: data.map(({ id_evenement, evenement, sport, pays, date }) => ({ id: id_evenement, text: `${evenement} (${sport} - ${pays}) - ${moment(date).format('LL')}` }))
          }
        }
      },
      minimumInputLength: 1
    })
  },
  select (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    if (id) {
      app.ajax({
        url: '/conseil',
        data: { id },
        complete: app.onComplete({
          success: (res) => {
            bootbox.dialog({
              message: require('views/templates/conseil/select')(res),
              size: 'large',
              backdrop: true,
              onEscape: true,
              buttons: { cancel: { label: 'Fermer' } }
            })
          }
        })
      })
    }
  }
})
